import { defineStore } from 'pinia';

export interface UTMState {
  source: string;
  channel: string;
}

export const useUTMStore = defineStore('utm', {
  state: (): UTMState => ({
    source: 'h5', // 该参数同时作为流量来源追踪及渠道标识符 // app_android
    channel: '',
  }),
  actions: {
    update(payload: Partial<UTMState>) {
      this.source = payload.source ?? this.source;
      this.channel = payload.channel ?? this.channel;
    },
  },
  persist: {},
});
